import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'shops/all',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/ShopsPageContainer'),
  }),
};
